import {combineReducers} from "redux";
import transferWithAmount from "./amount";
import percentage from "./percentage";
import shareConfig from "./shareConfig";
import shareConfigByLottery from "./shareConfigByLottery";

const transferReducer = combineReducers({
    transferWithAmount,
    percentage,
    shareConfig,
    shareConfigByLottery
});
export default transferReducer;
